function getTextBeforeAtSymbol(email) {
  if (!email) return "";

  const atIndex = email.indexOf("@");
  const textBeforeAt = atIndex !== -1 ? email.substring(0, atIndex) : email;

  return textBeforeAt.charAt(0).toUpperCase() + textBeforeAt.slice(1);
}
export default getTextBeforeAtSymbol;
